import React from 'react';
import { Box } from '@mui/material';
import Link from '@mui/material/Link';
import RenovationVoiceImage from '@components/common/RenovationVoiceImage';
import RenovationVoice from '@/types/components/RenovationVoice/RenovationVoice';

interface SPRenovationVoiceDetailProps {
  voice: RenovationVoice;
}

export default function SPRenovationVoiceDetail({ voice }: SPRenovationVoiceDetailProps): React.JSX.Element {
  return (
    <Box className="group w-full">
      <Link underline="none" href={voice['@context']} variant="body1" sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginTop: 1,
            flex: 6,
          }}
          className="mt-0 pl-5 pr-4 text-rf-blue max-md:leading-5.5 max-md:text-sm"
        >
          {voice.headline}
        </Box>
        <Box
          sx={{
            width: '100%',
            marginLeft: 'auto',
            marginRight: '-24px',
            flex: 4,
          }}
        >
          <RenovationVoiceImage
            src={voice.image[0]}
            alt={voice.headline}
            href={null}
            className="max-sm:h-[84px] max-md:h-40 aspect-video object-cover group-hover:opacity-60"
          />
        </Box>
      </Link>
    </Box>
  );
}
